const style = {
  load: {
    position: 'absolute',
    backgroundColor: 'white',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    zIndex: '1',
  },
  wrap: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
}

export default style
